module.exports = __webpack_public_path__ + "static/media/37_B.e8ccd1fb.png";